import { z } from 'zod';
import { categoryIdSchema, productIdSchema, taxRateIdSchema, tenantIdSchema } from '../ids/index.js';
import { cents } from '../money/index.js';
export const productSchema = z.object({
    id: productIdSchema,
    tenantId: tenantIdSchema,
    categoryId: categoryIdSchema.nullable(),
    sku: z.string().min(1).max(64),
    name: z.string().min(1).max(200),
    description: z.string().max(1000).nullable(),
    priceCents: cents,
    taxRateId: taxRateIdSchema.nullable(),
    imageUrl: z.string().url().nullable(),
    active: z.boolean().default(true),
    // DIAN future-ready fields (populated when módulo DIAN activates)
    dianItemCodeType: z.string().max(4).nullable().default(null),
    dianItemCode: z.string().max(64).nullable().default(null),
    // Sync bookkeeping
    version: z.number().int().min(1).default(1),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
    deletedAt: z.number().int().nullable().default(null),
});
export const categorySchema = z.object({
    id: categoryIdSchema,
    tenantId: tenantIdSchema,
    name: z.string().min(1).max(100),
    sortOrder: z.number().int().min(0).default(0),
    active: z.boolean().default(true),
    version: z.number().int().min(1).default(1),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
    deletedAt: z.number().int().nullable().default(null),
});
//# sourceMappingURL=product.js.map